// 油品调整
import { request,pretty } from '@/utils/request' 
export const ChatList = (item)=>{
  return pretty(request.get(`/api/ChatMessage/ChatList?appId=${item?.appId?(item?.appId):''}&appUserName=${item?.appUserName?(item?.appUserName):''}&title=${item?.title?(item?.title):''}&pageSize=${item?.pageSize?(item?.pageSize):10}&pageIndex=${item?.pageIndex?(item?.pageIndex):1}`));
}
export const ChatMessageDetail = (item)=>{
  return pretty(request.get(`/api/ChatMessage/ChatMessageDetail?msgId=${item}`));
}
export const ChatMessageList = (item)=>{
  return pretty(request.get(`/api/ChatMessage/ChatMessageList?chatId=${item.chatId}&reqCon=${item?.reqCon?(item?.reqCon):''}&repCon=${item?.repCon?(item?.repCon):''}`));
}